import { put, call, select } from 'redux-saga/effects';
import { RegistererState } from 'sip.js';
import { selectRegisterer, resetUserAgent } from '../../../state/userAgent/userAgentSlice';
import { ignoreCallSaga } from '../ignoreCall/ignoreCall';
import { selectCallSessions } from '../../../state/callSessions/callSessionsSlice';

export function* cleanupUASaga() {
    const callSessions = yield select(selectCallSessions);
    if (callSessions && callSessions.length > 0) {
        console.log('Terminating all active calls before cleanup...');
        for (const callSession of callSessions) {
            try {
                if (callSession.status === 'accepted') {
                    callSession.bye();
                } else if (callSession.status === 'outgoingProgressing') {
                    callSession.cancel();
                } else if (callSession.status === 'incomingProgressing') {
                    yield call(ignoreCallSaga, { payload: callSession });
                }
            } catch (e) {
                console.error('Error terminating call session during cleanup:', e);
            }
        }
    }
    const registerer = yield select(selectRegisterer);
    console.log('This is registerer state during cleanup', registerer.state, Date.now())

    if (registerer && registerer.state === RegistererState.Registered) {
        try {
            console.log('Trying to unregister the registerer from cleanupUA ', Date.now())
            registerer.unregister();
        } catch (e) {
            console.error('Error during SIP Registerer disposal:', e);
        }
    }

    yield put(resetUserAgent());
}